import { Link } from "react-router-dom";
import { Linkedin, Mail, ArrowUpRight } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    navigatie: [
      { href: "/", label: "Home" },
      { href: "/over-rabia", label: "Over Rabia" },
      { href: "/diensten", label: "Aanpak" },
      { href: "/referenties", label: "Referenties" },
      { href: "/contact", label: "Contact" },
    ],
    diensten: [
      { href: "/diensten#diagnose", label: "Diagnose" },
      { href: "/diensten#versnelling", label: "Versnelling" },
      { href: "/diensten#herstructurering", label: "Herstructurering" },
    ],
    legal: [
      { href: "/disclaimer", label: "Disclaimer" },
      { href: "/privacyverklaring", label: "Privacyverklaring" },
      { href: "/cookiebeleid", label: "Cookiebeleid" },
    ],
  };

  return (
    <footer data-testid="main-footer" className="bg-navy text-white">
      {/* Main Footer */}
      <div className="container-custom section-padding">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-12 lg:gap-8">
          {/* Brand Column */}
          <div className="lg:col-span-2">
            <Link to="/" className="inline-block mb-6">
              <span className="font-serif text-3xl md:text-4xl font-medium text-white">
                Regie op Cashflow
              </span>
            </Link>
            <p className="text-white/70 text-base leading-relaxed max-w-md mb-8">
              Een gefaseerde aanpak voor dienstverleners die omzet willen transformeren naar voorspelbare cashflow. Gedragen door meer dan 20 jaar ervaring in finance, procesoptimalisatie en teamontwikkeling.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://www.linkedin.com/in/rabia-boutkabout-857ab685/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-linkedin"
                className="p-3 bg-white/10 hover:bg-cta hover:text-white transition-all duration-300 rounded-sm"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href="mailto:rabia@regieopcashflow.nl"
                data-testid="footer-email"
                className="p-3 bg-white/10 hover:bg-cta hover:text-white transition-all duration-300 rounded-sm"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          {/* Navigation Column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-semibold text-cta mb-6">
              Navigatie
            </h4>
            <ul className="space-y-3">
              {footerLinks.navigatie.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    data-testid={`footer-nav-${link.href.replace("/", "") || "home"}`}
                    className="text-white/70 hover:text-cta transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-semibold text-cta mb-6">
              Aanpak
            </h4>
            <ul className="space-y-3">
              {footerLinks.diensten.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    data-testid={`footer-service-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/70 hover:text-cta transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h4 className="text-xs tracking-widest uppercase font-semibold text-cta mb-6">
              Juridisch
            </h4>
            <ul className="space-y-3">
              {footerLinks.legal.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    data-testid={`footer-legal-${link.href.replace("/", "")}`}
                    className="text-white/70 hover:text-cta transition-colors duration-300 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      {/* Company Information */}
      <div className="container-custom pb-8">
        <div className="border-t border-white/10 pt-8">
          <div className="text-center text-white/50 text-sm">
            <p className="font-medium text-white/70">RB Financial Management B.V.               KvK: 96319704</p>
          </div>
        </div>
      </div>

      {/* Large Brand Text */}
      <div className="container-custom pb-12 overflow-hidden">
        <div className="text-center">
          <span className="font-serif text-[8vw] md:text-[6vw] lg:text-[5vw] font-medium text-white/10 whitespace-nowrap">
            Regie op Cashflow
          </span>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="container-custom py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © {currentYear} Regie op Cashflow. Alle rechten voorbehouden.
            </p>
            <a
              href="https://calendly.com/rabia-regieopcashflow/30min"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-contact-link"
              className="flex items-center gap-2 text-cta hover:text-white transition-colors duration-300 text-sm font-medium"
            >
              Plan een gesprek
              <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
